import { CategoryID } from '@sbt-web/network/types';
import { slugify, urnTransformer } from '@sbt-web/utils';
import { getCategoryByID, isMacroCategory, getMacroOfCategoryID } from '@sbt-web/category-utils';

const getSearchMetaData = (id, rank) => ({
    '@id': id,
    '@type': 'SearchMetadata',
    source: 'MainSearch',
    rank,
});
const isCategoryID = (id) => Object.values(CategoryID).includes(id);
/**
 * Given a category ID string, retrieves the name of the category formatted for Pulse.
 * @returns The normalized name of the currently-selected category. If the ID is unknown, null is returned.
 */
const getCategory = (id) => {
    if (!isCategoryID(id))
        return null;
    if (id === CategoryID.Tutte) {
        return '';
    }
    else if (id === CategoryID.Altri) {
        return 'altro';
    }
    else if (id === CategoryID.AltriAnnunci) {
        return 'altro>altri';
    }
    const category = getCategoryByID(id);
    if (isMacroCategory(category)) {
        return slugify(category.label);
    }
    else {
        const macro = getMacroOfCategoryID(id);
        return `${slugify(macro.label)}>${slugify(category.label)}`;
    }
};
const getPostalAddress = function (city, town, region) {
    let locality;
    locality = `${city}`;
    if (town) {
        locality = `${city} > ${town}`;
    }
    return {
        '@type': 'PostalAddress',
        addressCountry: 'Italy',
        addressRegion: region,
        addressLocality: locality,
    };
};
const getPublisher = function (advertiserId, advertiserType) {
    return {
        type: 'Account',
        id: advertiserId,
        realm: 'subito',
        accountType: advertiserType === 1 ? 'Professional' : 'Private',
    };
};
const getAdType = function (adType) {
    switch (adType) {
        case 's':
            return 'sell';
        case 'k':
            return 'buy';
        case 'u':
            return 'rent';
        case 'h':
            return 'give';
        case 'In vendita':
            return 'sell';
        case 'Cercasi':
            return 'buy';
        case 'In affitto':
            return 'rent';
        default:
            return '';
    }
};
const getPublisherType = function (publisherType) {
    switch (publisherType) {
        case 0:
            return 'privato';
        case 1:
        case 2:
            return 'azienda';
        default:
            return '';
    }
};
const buildAdDetailTarget = function (item) {
    return {
        type: 'View',
        object: {
            type: 'ClassifiedAd',
            id: item.urn,
            name: document.title,
            category: getCategory(item.category.id),
            adId: urnTransformer(item.urn)?.adId,
            contentId: urnTransformer(item.urn)?.contentId,
            location: getPostalAddress(item.geo.city?.friendlyName || '', item.geo.town?.friendlyName || '', item.geo.region.friendlyName),
            publisher: getPublisher(item.advertiser.userId, item.advertiser.type),
            'spt:custom': {
                name: document.title,
                url: window.location.href,
                title: item.subject,
                inLanguage: 'it_IT',
                region: slugify(item.geo.region.friendlyName),
                locality: item.geo.town?.friendlyName && item.geo.city?.friendlyName
                    ? `${slugify(item.geo.city?.friendlyName)}>${slugify(item.geo.town?.friendlyName)}`
                    : item.geo.city?.friendlyName,
                price: item.features['/price']?.values[0]?.key,
                currency: 'EUR',
                adType: getAdType(item.type.key),
                publisherType: getPublisherType(item.advertiser.type),
            },
        },
    };
};
const getEnvByDomain = () => {
    const domain = window.location.hostname;
    if (domain.includes('.subito.it')) {
        return 'prod';
    }
    if (domain.includes('.regresssubito.it')) {
        return 'dev';
    }
    if (domain.includes('.piutardi.it')) {
        return 'stage';
    }
    return 'prod';
};

export { buildAdDetailTarget, getAdType, getCategory, getEnvByDomain, getPostalAddress, getPublisher, getPublisherType, getSearchMetaData };
//# sourceMappingURL=helpers.js.map
